import { Input, Stack, Text } from "@chakra-ui/react";
import { KYDAdminFeedItem } from "@common/interfaces/KYDOrganization";

const LinkInput = ({
  label,
  isDisabled = false,
  updateDirtyText,
  feedItem,
  dirtyText,
  valueFrom,
}: {
  feedItem?: KYDAdminFeedItem | null;
  dirtyText: Record<string, any>;
  updateDirtyText: (change: Record<string, any>) => void;
  label: string;
  isDisabled?: boolean;
  valueFrom: string;
}) => {
  return (
    <Stack spacing={0}>
      <Text>{label}</Text>
      <Input
        isDisabled={isDisabled}
        placeholder={label}
        onChange={(e) => {
          updateDirtyText({ [`item.${valueFrom}`]: e.target.value });
        }}
        value={
          `item.${valueFrom}` in dirtyText
            ? dirtyText[`item.${valueFrom}`]
            : feedItem
            ? feedItem[valueFrom]
            : ""
        }
      />
    </Stack>
  );
};

export default LinkInput;
